import { getSiblings, isDesktopMiddle } from '../../assets/js/utility';

// TODO: properly componentize or bring into header. Currently it relies on things only in header
class HeaderNav {
  constructor() {
    this.nav = document.querySelector('[data-navigation]');

    if (!this.nav) {
      return;
    }

    this.openButton = this.nav.parentNode?.querySelector('[data-navigation-button]');
    this.savedScrollNav = 0;
    this.savedScrollSubNav = 0;
    this.isDesktop = null;

    this.handleResize = this.handleResize.bind(this);
    this.handleOpenMenu = this.handleOpenMenu.bind(this);
    this.handleSubNavClick = this.handleSubNavClick.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
    this.handleItemMouseenter = this.handleItemMouseenter.bind(this);
    this.handleItemMouseleave = this.handleItemMouseleave.bind(this);
    this.handleSubNavItemMouseenter = this.handleSubNavItemMouseenter.bind(this);

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  handleResize() {
    const shouldBeDesktop = isDesktopMiddle();

    if (this.isDesktop === shouldBeDesktop) {
      return;
    }

    this.teardown();
    this.isDesktop = shouldBeDesktop;

    shouldBeDesktop ? this.setupDesktop() : this.setupMobile();
  }

  setupDesktop() {
    this.navItems.forEach((item) => {
      item.addEventListener('mouseenter', this.handleItemMouseenter);
      item.addEventListener('mouseleave', this.handleItemMouseleave);
    });

    this.subNavItems.forEach((item) => {
      item.addEventListener('mouseenter', this.handleSubNavItemMouseenter);
    });

    this.setSubNavigationItemsActive(true);
  }

  setupMobile() {
    this.openButton?.addEventListener('click', this.handleOpenMenu);

    this.subNavs.forEach((subNav) => {
      subNav.parentNode?.addEventListener('click', this.handleSubNavClick);
    });

    this.backButtons.forEach((button) => {
      button.addEventListener('click', this.handleBackClick);
    });

    this.setSubNavigationItemsActive(false);
  }

  teardown() {
    this.openButton?.removeEventListener('click', this.handleOpenMenu);

    this.navItems.forEach((item) => {
      item.removeEventListener('mouseenter', this.handleItemMouseenter);
      item.removeEventListener('mouseleave', this.handleItemMouseleave);
    });

    this.subNavItems.forEach((item) => {
      item.removeEventListener('mouseenter', this.handleSubNavItemMouseenter);
    });

    this.subNavs.forEach((subNav) => {
      subNav.parentNode?.removeEventListener('click', this.handleSubNavClick);
    });

    this.backButtons.forEach((button) => {
      button.removeEventListener('click', this.handleBackClick);
    });
  }

  get navItems() {
    return [...this.nav.querySelectorAll('[data-navigation-item]')];
  }

  get subNavs() {
    return [...this.nav.querySelectorAll('[data-subnavigation]')];
  }

  get subNavItems() {
    return [...this.nav.querySelectorAll('[data-subnavigation-item]')];
  }

  get backButtons() {
    return [...this.nav.querySelectorAll('[data-navigation-back]')];
  }

  handleItemMouseenter({ currentTarget }) {
    getSiblings(currentTarget, { attribute: 'data-navigation-item' }).forEach(
      (item) => {
        item.classList.remove('is-active-desktop');
      }
    );

    currentTarget.classList.add('is-active-desktop');
  }

  handleItemMouseleave({ currentTarget }) {
    currentTarget.classList.remove('is-active-desktop');
  }

  handleSubNavItemMouseenter({ currentTarget }) {
    const parent = currentTarget.closest('[data-subnavigation]');

    getSiblings(currentTarget, { attribute: 'data-subnavigation' }).forEach(
      (item) => {
        item.classList.remove('is-active-desktop');
        item
          .querySelector('[data-nested-navigation]')
          ?.classList.remove('is-active-desktop');
      }
    );

    currentTarget.classList.add('is-active-desktop');

    const nestedNav = currentTarget.querySelector('[data-nested-navigation]');
    if (!nestedNav || !parent) {
      return;
    }

    nestedNav.classList.add('is-active-desktop');
  }

  setSubNavigationItemsActive(setActive) {
    this.subNavs.forEach((subNav) => {
      if (!setActive) {
        subNav.querySelectorAll('.is-active-desktop').forEach((item) => {
          item.classList.remove('is-active-desktop');
        });

        subNav.style.height = '';
        return;
      }

      if (subNav.querySelector('.is-active-desktop')) {
        return;
      }

      const firstItem = subNav.querySelector('[data-subnavigation-item]');
      const nestedNav = firstItem?.querySelector('[data-nested-navigation]');

      firstItem?.classList.add('is-active-desktop');

      if (nestedNav) {
        nestedNav.classList.add('is-active-desktop');
      }
    });
  }

  handleOpenMenu() {
    this.nav.style.setProperty('--inner-height', `${window.innerHeight}px`);
    this.nav.classList.toggle('is-open');
    this.openButton?.classList.toggle('nav-opened');

    if (this.nav.classList.contains('is-open')) {
      return;
    }

    this.nav
      .querySelectorAll('[data-subnavigation], [data-nested-navigation]')
      .forEach((item) => {
        item.classList.remove('is-active');
      });
  }

  handleBackClick(evt) {
    evt.stopPropagation();

    const panel = evt.currentTarget.parentNode;
    if (!panel) {
      return;
    }

    panel.classList.remove('is-active');

    if (panel.hasAttribute('data-subnavigation')) {
      this.nav.classList.remove('no-scroll');
      this.nav.scrollTop = this.savedScrollNav;
      this.savedScrollNav = 0;
    }

    if (panel.hasAttribute('data-nested-navigation')) {
      const parent = panel.closest('[data-subnavigation]');
      if (!parent) {
        return;
      }

      parent.classList.remove('no-scroll');
      parent.scrollTop = this.savedScrollSubNav;
      this.savedScrollSubNav = 0;
    }
  }

  handleSubNavClick(evt) {
    if (evt.target.classList.contains('subnavigation__btn')) {
      return;
    }

    const item = evt.target.closest(
      '[data-navigation-item], [data-subnavigation-item]'
    );
    if (!item) {
      return;
    }

    const panel = item.querySelector(
      '[data-subnavigation], [data-nested-navigation]'
    );
    if (!panel) {
      return;
    }

    evt.preventDefault();
    panel.classList.add('is-active');

    if (panel.hasAttribute('data-subnavigation')) {
      this.savedScrollNav = this.nav.scrollTop;
      this.nav.classList.add('no-scroll');
      return;
    }

    const parent = panel.closest('[data-subnavigation]');
    if (!parent) {
      return;
    }

    this.savedScrollSubNav = parent.scrollTop;
    parent.classList.add('no-scroll');
  }
}

export default HeaderNav;
